import { useBitrix } from '@context/useBitrixUser/useBitrix';
import useMyRouting from '@context/useMyRouting/useMyRouting';
import { useBasketCounter } from '@pages/Basket/hooks/useBasketCounter';
import useBasket from '@pages/Basket/useBasket';
import React, { useEffect } from 'react';

const InitPersonalAccount = () => {
  const [settings] = useMyRouting().useSettings().useState();
  const initBasket = useBasket().actions.init;
  const initLocalization = useMyRouting().actions.init;
  const initBitrix = useBitrix().actions.init;

  useBasketCounter();

  const isSettingsNotInited = Object.values(settings).some((setting) => !setting);

  useEffect(() => {
    initLocalization();
  }, []);

  useEffect(() => {
    if (!isSettingsNotInited) {
      initBitrix();
      initBasket(settings.primaryLanguageId, settings.currencyId);
    }
  }, [isSettingsNotInited]);

  return <></>;
};

export default InitPersonalAccount;
